module.exports = __webpack_public_path__ + "img/beneficiary_active.ae0a21fa.svg";